import React, { useEffect, useRef, useState } from "react";
import { Grow, Grid } from "@mui/material";

import PieChart from "./components/PieChart";
import Funnel from "./components/Funnel";
import { useContext } from "react";
import AuthContext from "../../../context/AuthContext";
import { Typography } from "@mui/material";
import DayCard from "../../DayCard";
import PercentCard from "../../PercentCard";
import DollarCard from "../../DollarCard";
import NumberCard from "../../NumberCard";
export default function PositionSpecificView({
  positionChecked,
  posPieChartData,
  posFunnelData,
  data,
}) {
  let { isAdmin } = useContext(AuthContext);
  return (
    <Grid container spacing={3}>
      {isAdmin && (
        <Grow in={positionChecked} mountOnEnter unmountOnExit>
          <Grid item sx={{ width: "100%", ml:2 }}>
            <Typography color="#757575" variant="h4" >
              Position Metrics
            </Typography>
            <Typography variant="h5">{data.posName}</Typography>
          </Grid>
        </Grow>
      )}
      <Grow in={positionChecked} mountOnEnter unmountOnExit>
        <Grid item xl={4} lg={4} md={4} sm={6} xs={12}>
          <DayCard title={"Avg Time To Hire"} data={data.posATTH}/>
        </Grid>
      </Grow>
      <Grow
        in={positionChecked}
        style={{ transformOrigin: "0 0 0" }}
        {...(positionChecked ? { timeout: 1000 } : {})}
        mountOnEnter
        unmountOnExit
      >
        <Grid item xl={4} lg={4} md={4} sm={6} xs={12}>
          <PercentCard title={"Conversion Rate"} data={data.posCR} />
        </Grid>
      </Grow>
      <Grow
        in={positionChecked}
        style={{ transformOrigin: "0 0 0" }}
        {...(positionChecked ? { timeout: 1000 } : {})}
        mountOnEnter
        unmountOnExit
      >
        <Grid item xl={4} lg={4} md={4} sm={6} xs={12}>
          <DollarCard data={data.posCPH} title={"Cost Per Hire"}/>
        </Grid>
      </Grow>
      <Grow
        in={positionChecked}
        style={{ transformOrigin: "0 0 0" }}
        {...(positionChecked ? { timeout: 1000 } : {})}
        mountOnEnter
        unmountOnExit
      >
        <Grid item xl={4} lg={4} md={4} sm={6} xs={12}>
          <NumberCard title={"Active Vacancies"} data={data.posAV} />
        </Grid>
      </Grow>
      <Grow
        in={positionChecked}
        style={{ transformOrigin: "0 0 0" }}
        {...(positionChecked ? { timeout: 1000 } : {})}
        mountOnEnter
        unmountOnExit
      >
        <Grid item xl={4} lg={4} md={4} sm={6} xs={12}>
          <DayCard title={"Time To Fill"} data={data.posTTF} />
        </Grid>
      </Grow>
      <Grow
        in={positionChecked}
        style={{ transformOrigin: "0 0 0" }}
        {...(positionChecked ? { timeout: 1000 } : {})}
        mountOnEnter
        unmountOnExit
      >
        <Grid item xl={4} lg={4} md={4} sm={6} xs={12}>
          <PercentCard title={"Turnover Rate"} data={data.posTR} />
        </Grid>
      </Grow>
      <Grow
        in={positionChecked}
        style={{ transformOrigin: "0 0 0" }}
        {...(positionChecked ? { timeout: 1000 } : {})}
        mountOnEnter
        unmountOnExit
      >
        <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
          <PieChart data={posPieChartData} />
        </Grid>
      </Grow>
      <Grow
        in={positionChecked}
        style={{ transformOrigin: "0 0 0" }}
        {...(positionChecked ? { timeout: 1000 } : {})}
        mountOnEnter
        unmountOnExit
      >
        <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
          <Funnel data={posFunnelData} />
        </Grid>
      </Grow>
    </Grid>
  );
}
